<template>
  <div>
    <div :class="{'sticky-top': edit}">
      <div class="card m-b-0">
        <div class="card-body text-right m-r-30">
          <span v-if="edit">
            <a href @click.prevent="deleteTag()" class="btn btn-warning m-r-10">
              <i class="fa fa-trash"></i>
              Supprimer
            </a>
            <a href @click.prevent="saveTag()" class="btn btn-primary m-r-10">
              <i class="fa fa-save"></i>
              Enregistrer
            </a>
            <a href @click.prevent="setEdit(false)" class="btn btn-outline m-r-10">
              <i class="fa fa-times"></i>
            </a>
          </span>
          <span v-else>
            <a href @click.prevent="setEdit(true)" class="btn btn-outline m-r-10">
              <i class="fa fa-pencil"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <transition name="fade" mode="out-in">
          <div v-loading="loading">
            <div class="row">
              <div class="col-md-8">
                <div class="card">
                  <div class="card-header">
                    <h4>{{ storiesPagination.total }} Article(s) associé(s)</h4>
                  </div>
                  <div class="card-header">
                    <stories
                      :stories="stories"
                      :pagination="storiesPagination"
                      :toStory="toStory"
                      :setPage="setPage"
                    ></stories>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card card-user">
                  <div class="card-body">
                    <div>
                      <div v-if="!edit" class="tag">
                        <h4 class="title" :class="{'text-muted': !tag.label}">
                          <i class="fa fa-tag"></i>
                          {{ tag.label || 'Non précisé' }}
                          <br />
                        </h4>
                        <dl class="row">
                          <dt class="col-sm-4 m-b-30 text-right text-muted">Statut</dt>
                          <dd class="col-sm-8">{{ tag.status | translate }}</dd>
                          <dt class="col-sm-4 m-b-30 text-right text-muted">Type</dt>
                          <dd class="col-sm-8">{{ tag.scheme | translate }}</dd>
                        </dl>
                      </div>
                      <el-form v-else label-position="top" size="medium" label-width="100px">
                        <el-form-item>
                          <span slot="label">
                            <i class="fa fa-tag"></i>
                            Intitulé
                          </span>
                          <el-input @input="updateTagAttribute('label', $event)" :value="tag.label"></el-input>
                        </el-form-item>
                        <el-form-item>
                          <span slot="label">
                            <i class="fa fa-tag"></i>
                            Description
                          </span>
                          <el-input
                            type="textarea"
                            @input="updateTagAttribute('description', $event)"
                            :autosize="{ minRows: 2, maxRows: 10}"
                            :value="tag.description"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="Statut">
                          <el-select
                            @change="updateTagAttribute('status', $event)"
                            :value="tag.status"
                          >
                            <el-option
                              v-for="item in constants.TAG_STATUSES"
                              :label="$t(`${item}`)"
                              :key="item"
                              :value="item"
                            >{{ $t(`${item}`) }}</el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="Type">
                          <el-select
                            @change="updateTagAttribute('scheme', $event)"
                            :value="tag.scheme"
                          >
                            <el-option
                              v-for="item in constants.TAG_SCHEMES"
                              :label="$t(`${item}`)"
                              :key="item"
                              :value="item"
                            >{{ $t(`${item}`) }}</el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="tag.scheme === 'PROGRAM'" label="VERSION AUDIO">
                          <el-checkbox
                            name="audio_enabled"
                            v-model="attributes.audio_enabled"
                          >Cette émission dispose de versions audio.</el-checkbox>
                        </el-form-item>
                        <div v-if="tag.scheme == 'PODCAST' || attributes.audio_enabled">
                          <el-form-item
                            v-for="platform in constants.PODCAST_PLATFORMS"
                            :key="platform"
                            :label="platform"
                          >
                            <el-input :name="platform" v-model="attributes[platform]"></el-input>
                          </el-form-item>
                        </div>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <pre>{{ constants }}</pre> -->
            <!-- <pre>{{ attributes }}</pre> -->
            <!-- <pre>{{ tag }}</pre> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters({
    constants: "constants",
    tag: "tag",
    stories: "stories",
    storiesPagination: "storiesPagination"
  }),
  components: {},
  data() {
    return {
      loading: true,
      edit: false,
      mask:
        "id,status,label,description,scheme,attributes,created_at,updated_at",
      storiesMask:
        "id,title,slug,status,thumb_story_list_url,scheme,created_at," +
        "published_at,authors{id,screenname}" +
        "tags{id,scheme,label}",
      storiesFilters: {
        tags_ids: this.$route.params.id,
        page: 1,
        per_page: 25
      },
      attributes: {}
    };
  },
  watch: {
    $route(to, from) {
      this.edit = to.query.edit;
      this.init();
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.edit) {
        this.edit = this.$route.query.edit;
      }
      this.$store.dispatch("getConstants", {
        params: {
          keys: "TAG_STATUSES,TAG_SCHEMES,PODCAST_PLATFORMS"
        }
      });
      this.$store
        .dispatch("getTag", {
          id: this.$route.params.id,
          headers: {
            "X-Fields": this.mask
          }
        })
        .then(() => {
          this.loading = false;
          this.attributes = Object.assign({}, this.tag.attributes);
        });
      this.$store.dispatch("getStories", {
        params: this.storiesFilters,
        headers: { "x-fields": this.storiesMask }
      });
    },
    saveTag() {
      this.loading = true;
      this.updateTagAttribute("attributes", this.attributes);
      this.$store
        .dispatch("saveTag", {
          headers: {
            "X-Fields": this.mask,
            "X-UpdateKeys":
              "status,label,description,scheme,attributes,updated_at"
          }
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Tag enregistré avec succès"
          });
          this.loading = false;
        });
    },
    deleteTag() {
      this.$confirm(
        "Ceci effacera le tag ainsi que toutes ses utilisations. Continuer ?",
        "Warning",
        {
          confirmButtonText: "Supprimer",
          cancelButtonText: "Annuler",
          type: "warning"
        }
      )
        .then(() => {
          this.$store
            .dispatch("deleteTag", {
              id: this.$route.params.id,
              headers: {
                "X-Fields": this.mask
              }
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Auteur supprimé"
              });
              this.$router.replace({
                name: "tags"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée"
          });
        });
    },
    updateTagAttribute(key, value) {
      let data = {
        [key]: value
      };
      this.$store.commit("UPDATE_TAG_VALUE", data);
    },
    toStory(storyId) {
      this.$router.push({
        name: "story",
        params: { id: storyId }
      });
    },
    setPage(page) {
      window.scrollTo(0, 0);
    },
    setEdit(edit) {
      this.$router.push({
        name: "tag",
        params: { id: this.$route.params.id },
        query: { edit: edit }
      });
    }
  }
};
</script>
<style>
</style>
